import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Plate } from 'src/app/interfaces/Responses/IRealTimeDashboardResponse';

@Component({
  selector: 'neoris-list-plates',
  templateUrl: './list-plates.component.html',
  styleUrls: ['./list-plates.component.css']
})
export class ListPlatesComponent  {

  @Input() listPlates: Plate[];
  @Output() tripID: EventEmitter<string> = new EventEmitter<string>()
  @Output() event = new EventEmitter()

  constructor() { 
    console.log('constructor')
  }

 

  getDetail(plate: Plate) {
    this.tripID.emit(plate.triP_ID.toString())
    setTimeout(() => {
      this.event.emit(null)
    }, 1000);
  }

}
